import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { useDispatch, useSelector } from "react-redux";

function AddProductSection({ register, getValues, watch, setValue, errors }) {
  const { sectionList, taxList } = useSelector((state) => state.usersetting);
  const { branchsettings } = useSelector((state) => state.settings);
  const [toggleActiveAll, setToggleActiveAll] = useState(false);
const [bulkPrice, setBulkPrice] = useState("");
  const columns = [
    {
      title: "Is Active",
      dataIndex: "",
      render: (_, value, index) => (
        <input
          type="checkbox"
          className=""
          {...register(`sectionWiseProductDetailList[${index}].IsActive`)}
        />
      ),
    },
    {
      title: "Section",
      dataIndex: "name",
      render: (_, value, index) => (
        <div>
          <select
            name=""
            id=""
            className="form-control"
            {...register(`sectionWiseProductDetailList[${index}].Section`)}
          >
            <option value={value.guid} key={value.id}>
              {value.name}
            </option>
          </select>
        </div>
      ),
    },
    {
      title: "Price",
      dataIndex: "",
      render: (_, val, index) => (
        <div>
          <input
            type="number"
            className="form-control w-50"
            step="any"
            min={0}
            {...register(`sectionWiseProductDetailList[${index}].Price`)}
          />
        </div>
      ),
    },

    ...(branchsettings.disableTaxInSale == false
      ? [
          {
            title: "Tax",
            dataIndex: "",

            render: (_, value, index) => (
              <div>
                <select
                  name=""
                  id=""
                  className="form-control"
                  {...register(`sectionWiseProductDetailList[${index}].Tax`)}
                  value={watch().sectionWiseProductDetailList[index].Tax}
                  onChange={(e) => {
                    const selectedTax = e.target.value;
                    if (selectedTax === "") {
                      setValue(
                        `sectionWiseProductDetailList[${index}].Tax`,
                        ""
                      );

                      setValue(
                        `sectionWiseProductDetailList[${index}].IsTaxIncludedInPrice`,
                        false
                      );
                    } else
                      setValue(
                        `sectionWiseProductDetailList[${index}].Tax`,
                        e.target.value
                      );
                  }}
                >
                  <option value=""> select</option>
                  {taxList &&
                    taxList?.map((obj) => {
                      return (
                        <option value={obj.guid} key={obj.id}>
                          {obj.name}
                        </option>
                      );
                    })}
                </select>
              </div>
            ),
          },
          {
            title: "Tax Inclusive",
            dataIndex: "",
            render: (_, value, index) => {
              const taxSelected = watch(
                `sectionWiseProductDetailList[${index}].Tax`
              );
              return (
                <input
                  type="checkbox"
                  className=""
                  {...register(
                    `sectionWiseProductDetailList[${index}].IsTaxIncludedInPrice`
                  )}
                  // required={taxSelected}
                  disabled={!taxSelected} // Disable if no tax is selected
                />
              );
            },
          },
        ]
      : []),
  ];

const [selectedTaxGuid, setSelectedTaxGuid] = useState("");
const [isTaxIncluded, setIsTaxIncluded] = useState(false);

const handleApplyTaxToAll = () => {
  const list = watch("sectionWiseProductDetailList") || [];

  list.forEach((_, index) => {
    // Update Tax if selected
    if (selectedTaxGuid)
      setValue(`sectionWiseProductDetailList[${index}].Tax`, selectedTaxGuid);

    // Update Tax Inclusive if a tax is selected
    setValue(
      `sectionWiseProductDetailList[${index}].IsTaxIncludedInPrice`,
      selectedTaxGuid ? isTaxIncluded : false
    );

    // Update Active checkbox
    setValue(`sectionWiseProductDetailList[${index}].IsActive`, toggleActiveAll);

    // Update Price if entered
    if (bulkPrice !== "")
      setValue(`sectionWiseProductDetailList[${index}].Price`, parseFloat(bulkPrice));
  });
};


  return (
    <div>
      {Object.keys(errors || {})
        .map((key) => errors[key]?.message)
        .find(Boolean) && (
        <span className="error text-danger text-sm">
          {Object.keys(errors || {})
            .map((key) => errors[key]?.message)
            .find(Boolean)}
        </span>
      )}

  <div className="modal-body custom-modal-body">
  <div className="d-flex flex-wrap align-items-center gap-5">

    {/* Apply Tax */}
    <div className="d-flex align-items-center gap-5">
{/* Mark All Active */}
    <div className="form-check d-flex align-items-center gap-2 mb-0">
      <input
        className="form-check-input"
        type="checkbox"
        checked={toggleActiveAll}
       onChange={(e) => setToggleActiveAll(e.target.checked)}
      />
      <label className="form-check-label mb-0">Is Active</label>
    </div>
    {/* Price */}
    <div className="d-flex align-items-center gap-4">
      <label className="mb-0">Price:</label>
      <input
        type="number"
        className="form-control"
        placeholder="Enter Price"
        style={{ minWidth: "120px" }}
        onChange={(e) => setBulkPrice(e.target.value)}
      />
    </div>
    <div className="form-check d-flex align-items-center gap-2 mb-0">
      <label className="mb-0">Tax:</label>
      <select
        className="form-select"
        value={selectedTaxGuid}
        onChange={(e) => setSelectedTaxGuid(e.target.value)}
        style={{ minWidth: "150px" }}
      >
        <option value="">Select Tax</option>
        {taxList?.map((tax) => (
          <option value={tax.guid} key={tax.id}>{tax.name}</option>
        ))}
      </select>
    </div></div>


    {/* Tax Inclusive */}
    <div className="form-check d-flex align-items-center gap-2 mb-0">
      <input
        type="checkbox"
        className="form-check-input"
        checked={isTaxIncluded}
        onChange={(e) => setIsTaxIncluded(e.target.checked)}
        disabled={!selectedTaxGuid}
      />
      <label className="form-check-label mb-0">Tax Inclusive</label>
    </div>

    {/* Apply Button */}
    <div>
      <button
        type="button"
        className="btn btn-warning fw-semibold"
        onClick={handleApplyTaxToAll}
      >
        Apply to All
      </button>
    </div>

  </div>
</div>


      <div className="table-responsive product-list">
        <Table columns={columns} dataSource={sectionList} pagination={false} />
      </div>
    </div>
  );
}

export default AddProductSection;
